import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Schedule, ScheduleFlag } from '../../../domain/schedule.model';
import { GenericService } from './generic.service';

@Injectable()
export class ScheduleService extends GenericService {

    constructor(private store: Store, private http: HttpClient) {
        super(store);
    }

    getFlag(): Observable<ScheduleFlag> {
        return this.http.get<ScheduleFlag>('/api/secured/timetable/flag', {});
    }

    getAll(): Observable<Schedule[]> {
        return this.http.get<Schedule[]>('/api/secured/timetable', {});
    }

    delete(id: number) {
        return this.http.delete<any>(`/api/secured/timetable/${id}`, {});
    }

    save(schedule: Schedule) {
        if (schedule.id) {
            return this.http.put<Schedule>(`/api/secured/timetable/${schedule.id}`, schedule)
                .pipe(catchError(this.errorsAside), tap(this.cleanAside));
        } else {
            return this.http.post<Schedule>(`/api/secured/timetable`, schedule)
                .pipe(catchError(this.errorsAside), tap(this.cleanAside));
        }

    }
}
